import { createContext, createElement, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeCtx = createContext({ me: null, loading: true, refresh: () => {} });

export function MeProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!isSignedIn) { setMe(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/me");
      setMe(data); setError("");
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not load your account");
    } finally { setLoading(false); }
  }, [api, isSignedIn]);

  useEffect(() => { if (isLoaded) refresh(); }, [isLoaded, refresh]);
  useEffect(() => {
    if (!isSignedIn) return;
    const t = setInterval(refresh, 20000);
    return () => clearInterval(t);
  }, [isSignedIn, refresh]);

  return createElement(MeCtx.Provider, { value: { me, loading: !isLoaded || loading, error, refresh } }, children);
}

export const useMe = () => useContext(MeCtx);
